{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Atributos Personalizados",
    "HEADER_BTN_TXT": "Criar atributo personalizado",
    "LOADING": "Buscando atributos personalizados",
    "DESCRIPTION": "Um atributo personalizado controla detalhes adicionais sobre seus contatos ou conversas — como o plano de assinatura ou a data de sua primeira compra. Você pode adicionar diferentes tipos de atributos personalizados, como texto, listas ou números, para capturar as informações específicas que você precisa.",
    "LEARN_MORE": "Saiba mais sobre atributos personalizados",
    "COUNT": "{n} atributo | {n} atributos",
    "SEARCH_PLACEHOLDER": "Pesquisar atributos...",
    "NO_RESULTS": "Nenhum atributo encontrado correspondente à sua busca",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Conversas",
      "CONTACT": "Contato",
      "COMPANY": "Empresa"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Texto",
      "NUMBER": "Número",
      "LINK": "Link",
      "DATE": "Data",
      "LIST": "Lista",
      "CHECKBOX": "Caixa de seleção"
    },
    "ADD": {
      "TITLE": "Adicionar atributo personalizado",
      "SUBMIT": "Criar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "FORM": {
        "NAME": {
          "LABEL": "Nome para exibição",
          "PLACEHOLDER": "Digite um nome de exibição de atributo personalizado",
          "ERROR": "O nome é obrigatório"
        },
        "DESC": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Inserir descrição do atributo personalizado",
          "ERROR": "Descrição obrigatória"
        },
        "MODEL": {
          "LABEL": "Aplica-se a",
          "PLACEHOLDER": "Por favor, selecione um",
          "ERROR": "O modelo é necessário"
        },
        "TYPE": {
          "LABEL": "Tipo",
          "PLACEHOLDER": "Selecione um tipo",
          "ERROR": "O tipo é obrigatório",
          "LIST": {
            "LABEL": "Listar valores",
            "PLACEHOLDER": "Por favor, digite o valor e pressione Enter",
            "ERROR": "Deve ter pelo menos um valor"
          }
        },
        "KEY": {
          "LABEL": "Chave",
          "PLACEHOLDER": "Digite a chave de atributo personalizada",
          "ERROR": "A chave é obrigatória",
          "IN_VALID": "Chave inválida"
        },
        "REGEX_PATTERN": {
          "LABEL": "Expressão Regex",
          "PLACEHOLDER": "Por favor, insira o padrão de expressão regular para atributo personalizado. (Opcional)"
        },
        "REGEX_CUE": {
          "LABEL": "Orientação de validação Regex",
          "PLACEHOLDER": "Por favor, insira uma dica para o padrão de expressão regular. (Opcional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Habilitar validação do regex"
        },
        "BADGES": {
          "PRE_CHAT": "Pré-chat",
          "RESOLUTION": "Resolução"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado adicionado com sucesso!",
        "ERROR_MESSAGE": "Não foi possível criar um atributo personalizado. Por favor, tente novamente mais tarde."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado excluído com sucesso.",
        "ERROR_MESSAGE": "Não foi possível excluir o atributo personalizado. Tente novamente."
      },
      "CONFIRM": {
        "TITLE": "Tem certeza que deseja excluir - {attributeName}",
        "PLACE_HOLDER": "Digite {attributeName} para confirmar",
        "MESSAGE": "Excluindo removerá o atributo personalizado",
        "YES": "Excluir ",
        "NO": "Cancelar"
      }
    },
    "EDIT": {
      "TITLE": "Editar atributo personalizado",
      "UPDATE_BUTTON_TEXT": "Atualizar",
      "TYPE": {
        "LIST": {
          "LABEL": "Listar valores",
          "PLACEHOLDER": "Por favor, insira valores e pressione Enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado atualizado com sucesso",
        "ERROR_MESSAGE": "Houve um erro ao atualizar atributo personalizado, por favor, tente novamente"
      }
    },
    "TABS": {
      "HEADER": "Atributos Personalizados",
      "CONVERSATION": "Conversas",
      "CONTACT": "Contato",
      "COMPANY": "Empresa"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nome",
        "DESCRIPTION": "Descrição",
        "TYPE": "Tipo",
        "KEY": "Chave"
      },
      "BUTTONS": {
        "EDIT": "Alterar",
        "DELETE": "Excluir"
      },
      "EMPTY_RESULT": {
        "404": "Não há atributos personalizados criados",
        "NOT_FOUND": "Não há atributos personalizados configurados"
      },
      "REGEX_PATTERN": {
        "LABEL": "Expressão Regex",
        "PLACEHOLDER": "Por favor, insira o padrão de expressão regular para atributo personalizado. (Opcional)"
      },
      "REGEX_CUE": {
        "LABEL": "Orientação de validação Regex",
        "PLACEHOLDER": "Por favor, insira uma dica para o padrão de expressão regular. (Opcional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Habilitar validação da expressão regular"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pré-chat",
      "RESOLUTION": "Resolução"
    }
  }
}
